import Skeleton from 'react-loading-skeleton';

/**
 * Renders the loading placeholder for an event detail parameters card. Lays out a header and a content container, each filled with a full-height skeleton block.
 *
 * @returns The skeleton card element.
 */
const DetailCardSkeleton = () => (
  <div className="detail-card-skeleton-container">
    <div className="header-container">
      <Skeleton height="100%" />
    </div>

    <div className="content-container">
      <Skeleton height="100%" />
    </div>
  </div>
);

export default DetailCardSkeleton;
